import React from 'react';

import PropTypes from 'prop-types';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const MyCheckbox = ({
  label,
  checked,
  disabled,
  onChange = () => {},
  name,
  parent,
  sx = {},
}) => {
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(e) => onChange({ ...e, parent, name })}
            checked={checked}
            name={name}
            disabled={disabled}
            sx={sx}
          />
        }
        label={label}
      />
    </FormGroup>
  );
};

MyCheckbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default MyCheckbox;
